import sectionItemsGrid03Css from '../css-snippets/section-items-grid-03';

const html = `
<style>${sectionItemsGrid03Css}</style>
<div
  id="items-grid-section-unique-id"
  data-id="unique-id"
  class="items-grid-wrapper"
  data-attribute="items-grid-wrapper"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-card-background-color="#14A16C"
  data-card-text-color="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-background-image="false"
  data-card-border-radius="12"
  data-item-image-width-mobile="60"
  data-item-image-width-desktop="60"
  style="
    --background-color: #ffffff; 
    --text-color: #000000; 
    --card-text-color: #ffffff; 
    --card-background-color: #14A16C;
    --card-border-radius: 12px;
    --item-image-width-mobile: 60px;
    --item-image-width-desktop: 60px;
  "
>
  <div
    data-attribute="items-grid-content"
    class="items-grid-content container"
    data-container-full-width="false"
  >
    <div data-attribute="title-content" class="items-grid-header">
      <figure class="image image_resized" style="width:50%;">
        <img src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb372af6e324be1cdd8dd3.png?q=80">
      </figure>
      <h2 style="text-align: center">
        <strong>Top Rated Natural Lung Supplement for Adults &amp; Kids</strong>
      </h2>
      <p style="text-align: center">
        Sold to over <strong>50</strong> countries
      </p>
      <p style="text-align: center">
        Over <strong>600,000</strong> happy customers worldwide
      </p>
      <p style="text-align: center">
        Over <strong>2,000,000</strong> boxes sold
      </p>
    </div>
    <div
      data-attribute="list-item"
      class="items-grid-list"
      data-items-per-row-mobile="2"
      data-items-per-row-desktop="4"
      style="--items-per-row-mobile: 2; --items-per-row-desktop: 4"
    >
      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb825632b0607a67c5582a.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Natural Ingredients</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb8262139a43c42338867c.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Vegan Friendlye</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb8275e5b1b715055519d8.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Non-GMO</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb8281f2a29bb2dcdf6371.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>No Preservatives</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb828ed1675127773820ee.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Gluten-Free</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb82a6382de81257b1f3fd.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Egg-Free</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb82b21a851f82c450df26.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Dairy-Free</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb82bf5e3bf450a8303f08.png?w=100&h=50&q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <p>Peanut-Free</p>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
